"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Parser_1 = require("../Parser");

var parserSupport_1 = require("../parserSupport");
/**
 * Parses boolean from string based on emptiness.
 * @author OPt
 */


var NotEmptyBooleanParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(NotEmptyBooleanParser, _Parser_1$Parser);

  function NotEmptyBooleanParser() {
    var _this;

    var notEmptyValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    _classCallCheck(this, NotEmptyBooleanParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotEmptyBooleanParser).call(this));
    _this.notEmptyValue = notEmptyValue;
    return _this;
  }

  _createClass(NotEmptyBooleanParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (input && input.length > 0) {
        return parserSupport_1.succ(this.notEmptyValue);
      }

      return parserSupport_1.succ(!this.notEmptyValue);
    }
  }]);

  return NotEmptyBooleanParser;
}(Parser_1.Parser);

exports.NotEmptyBooleanParser = NotEmptyBooleanParser;